export const DOM_KEY_QUERY_BUILDER_DATASETS_SEGMENTED_CONTROL =
  'segmented-control';
export const DOM_KEY_QUERY_BUILDER_DATASETS_CUSTOM_ADS_MULTI_DROPDOWN =
  'custom-ads-datasets';
export const DOM_KEY_BODY = 'body';
export const DOM_KEY_FOOTER = 'footer';
